export enum InvoiceType {
    Bulk = 0,
    Individual = 1,
    Voucher = 2,
    AnnualFee = 3,
    OrderCancellation = 4,
}
